import { Icon } from "./Icon.js";
import "./Spinner.css";

export type SpinnerSize = "sm" | "md";

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  /** Defaults to a generic label since a spinner alone conveys no reason —
   * override with what's actually loading when known (e.g. "Loading messages"). */
  label?: string;
}

const PX: Record<SpinnerSize, number> = { sm: 14, md: 20 };

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps) {
  return (
    <span className={["ui-spinner", className ?? ""].filter(Boolean).join(" ")} role="status">
      <Icon name="spinner" size={PX[size]} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
